var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"symbols"},[_c('BaseIconButton',{attrs:{"button-style":'tonal'},nativeOn:{"click":function($event){return _vm.showAddSymbolModal()}},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('i',{staticClass:"material-symbols-outlined"},[_vm._v("add")])]},proxy:true}])}),_c('SymbolsChipsList',{attrs:{"symbols":_vm.charts}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }